import React from 'react';
import OVERRIDE from 'assets/img/ok.svg';
import CUSTOMIZE from 'assets/img/black/wrench.svg';
import './style.scss';

export const AprroveCustomizeIcons = ({
  isOverride, isCustomize, customizeText = 'Customized Selection', overrideText = 'Overriden Address',
}) => (
  <div className="overrideBlock">
    {isOverride && (
    <div className="overrideBlock_cell">
      <img src={OVERRIDE} alt="override icon" />
      <p>{overrideText}</p>
    </div>
    )}
    {isCustomize && (
    <div className="overrideBlock_cell">
      <img src={CUSTOMIZE} alt="customize icon" />
      <p>{customizeText}</p>
    </div>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/view/common/AprroveCustomizeIcons/index.jsx